import { Alert, Card, CommonProp, DataTable } from '@acin/ui-core';
import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { REGULATION_TABS } from '../../../helpers';
import { useIntersectionObserver } from '../../../hooks';
import { getRegulationDetailPath } from '../../../routes/routes';
import { StatusBadge } from '../../StatusBadge';
import { useHomepageRegulations } from '../hooks/useHomepageRegulations';
import { TABLE_HEADERS } from '../utils';
import * as SC from './RegulationsOverview.styled';

export interface ConnectMenuProps extends CommonProp {
  className?: string;
}

export const RegulationsOverview: React.FC<ConnectMenuProps> = (props) => {
  const { className } = props;
  const sentinelRef = useRef<HTMLDivElement>(null);
  const history = useHistory();

  const { data, loading, error, pageInfo, activeSorting, onSort, handleFetchMore } = useHomepageRegulations();

  useIntersectionObserver(sentinelRef, handleFetchMore);

  if (error) {
    return <Alert status="error" title="Failed to load regulations. Please try again later." />;
  }

  const rows = (data?.internalRegulations.edges ?? []).map((reg) => ({
    id: reg.node.id ?? '',
    title: reg.node.title,
    status: <StatusBadge status={reg.node.status} />,
  }));

  const handleRowClick = (regulationId: string) => {
    history.push(getRegulationDetailPath(regulationId, REGULATION_TABS.REVIEW.id));
  };

  return (
    <SC.RegulationsOverview data-testid="regulations-overview" className={className}>
      <Card>
        <DataTable
          headers={TABLE_HEADERS}
          rows={rows}
          variation="primary"
          activeSorting={{
            key: activeSorting.field,
            direction: activeSorting.direction,
          }}
          onSort={onSort}
          onRowClick={handleRowClick}
        />
        {loading && <SC.LoadingIndicator />}
        {pageInfo?.hasNextPage && <SC.Sentinel ref={sentinelRef} />}
      </Card>
    </SC.RegulationsOverview>
  );
};
